import { OnlyOfficeEditor } from "@/components/common/OnlyOfficeEditor.tsx";
import {
	Form,
	FormDescription,
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import Select from "@/components/core/forms/select";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { IconCube, IconX } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Button } from "../core/buttons/button";
import FormCalendar from "../core/forms/form-calendar";
import TagsInput from "../core/forms/tags-input";
import { Textarea } from "../core/forms/textarea";

export default function InlineOfficeModal() {
	const { closeModal } = useModalControl();
	const form = useForm({
		defaultValues: {
			id: 1,
		},
	});

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full">
					<div className="flex flex-row items-center justify-between w-full h-[50px] px-4 bg-slate-50 border-b border-slate-200">
						<span className="text-base font-bold text-foreground-dark">
							Action Title
						</span>
						<div className="inline-flex flex-row w-auto gap-3">
							<div className="inline-flex flex-row w-auto gap-1">
								<Button variant="ghost" size="icon">
									<IconCube size={18} stroke={2} />
								</Button>
								<Button variant="ghost" size="icon">
									<IconCube size={18} stroke={2} />
								</Button>
								<Button variant="ghost" size="icon">
									<IconCube size={18} stroke={2} />
								</Button>
							</div>
							<div className="inline-flex flex-row w-auto gap-1">
								<Button variant="ghost" size="icon">
									<IconCube size={18} stroke={2} />
								</Button>
								<Button variant="ghost" size="icon">
									<IconCube size={18} stroke={2} />
								</Button>
								<Button variant="ghost" size="icon">
									<IconCube size={18} stroke={2} />
								</Button>
							</div>
							<Button
								onClick={() => {
									closeModal();
								}}
								type="button"
								variant="ghost"
								size="icon"
							>
								<IconX size={18} stroke={2} />
							</Button>
						</div>
					</div>
					<div className="flex grow shrink flex-row w-full h-full">
						<PanelGroup
							className="flex flex-row grow w-full"
							direction="horizontal"
						>
							<Panel
								defaultSize={20}
								minSize={20}
								className="flex flex-col shrink-0 grow max-w-[420px]"
							>
								<div className="grid grid-cols-12 w-full p-4 gap-3 py-3 overflow-y-auto">
									<div className="col-span-12 w-full">
										<FormField
											control={form.control}
											name="reply"
											render={({ field }) => (
												<FormItem>
													<div className="flex flex-col w-full">
														<FormLabel required>Recipient</FormLabel>
													</div>
													<FormGroup>
														<Select
															onValueChange={async (value) => {
																field.onChange(value);
																// setServiceType(value)
															}}
															defaultValue={field.value}
															options={[
																{
																	value: "Plaintiff",
																	label: "Plaintiff",
																},
																{
																	value: "Defendant",
																	label: "Defendant",
																},
															]}
														/>
													</FormGroup>
													<FormMessage />
												</FormItem>
											)}
										/>
									</div>
									<div className="col-span-12 w-full">
										<FormField
											control={form.control}
											name="title"
											render={({ field }) => (
												<FormItem>
													<div className="flex flex-col w-full">
														<FormLabel required>Activity</FormLabel>
													</div>
													<FormGroup>
														<Select
															onValueChange={async (value) => {
																field.onChange(value);
																// setServiceType(value)
															}}
															defaultValue={field.value}
															options={[
																{
																	value: "Summons",
																	label: "Summons",
																},
																{
																	value: "Pre Trial",
																	label: "Pre Trial",
																},
																{
																	value: "Order",
																	label: "Order",
																},
															]}
														/>
													</FormGroup>
													<FormMessage />
												</FormItem>
											)}
										/>
									</div>
									<div className="col-span-12 w-full">
										<FormField
											control={form.control}
											name="title"
											render={({ field }) => (
												<FormItem>
													<div className="flex flex-col w-full">
														<FormLabel>Activity</FormLabel>
														<FormDescription />
													</div>
													<FormGroup>
														<TagsInput
															isMulti={false}
															onValueChange={async (value) => {
																field.onChange(value.value);
															}}
															defaultValue={field.value}
															options={[
																{ label: "Summons", value: "Summons" },
																{
																	label: "Pre-Trial Conference",
																	value: "Pre-Trial Conference",
																},
																{
																	label: "Pre-Trial Brief",
																	value: "Pre-Trial Brief",
																},
																{ label: "Motion", value: "Motion" },
																{ label: "Answer", value: "Answer" },
																{ label: "Order", value: "Order" },
																{
																	label: "Reply to Answer",
																	value: "Reply to Answer",
																},
																{
																	label: "Summary Judgment",
																	value: "Summary Judgment",
																},
															]}
														/>
													</FormGroup>
													<FormMessage />
												</FormItem>
											)}
										/>
									</div>
									<div className="col-span-12 w-full">
										<FormField
											control={form.control}
											name="due_date"
											render={({ field }) => (
												<FormItem>
													<div className="flex flex-col w-full">
														<FormLabel>Due Date</FormLabel>
													</div>
													<FormGroup>
														<FormCalendar
															onChange={(date) => console.log(date)}
															id="calendar"
															showIcon={true}
														/>
													</FormGroup>
													<FormMessage />
												</FormItem>
											)}
										/>
									</div>
									<div className="col-span-12 w-full ">
										<FormField
											control={form.control}
											name="remarks"
											render={({ field }) => (
												<FormItem>
													<div className="flex flex-col w-full">
														<FormLabel required>Remarks</FormLabel>
														<FormDescription />
													</div>
													<FormGroup>
														<Textarea {...field} />
													</FormGroup>
													<FormMessage />
												</FormItem>
											)}
										/>
									</div>
								</div>
								<div className="flex flex-row w-full gap-2 mt-auto">
									<Button className="w-full" variant="ghost">
										Clear
									</Button>
									<Button className="w-full">Submit</Button>
								</div>
							</Panel>

							<PanelResizeHandle className="group flex justify-center items-center w-[12px] border-r border-l border-border/50 bg-white">
								<div className="inline-flex w-[4px] h-[40px] rounded-sm bg-foreground/50 group-hover:bg-foreground/90" />
							</PanelResizeHandle>

							<Panel
								defaultSize={50}
								minSize={10}
								className="flex flex-col shrink grow w-full"
							>
								<OnlyOfficeEditor />
							</Panel>
						</PanelGroup>
					</div>
				</div>
			</form>
		</Form>
	);
}
